"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var T = __importStar(require("./effect"));
/* tested in wave */
/* istanbul ignore next */
exports.natNumber = function (msg) { return function (n) {
    return n < 0 || Math.round(n) !== n ? T.raiseAbort(msg) : T.unit;
}; };
